import React from 'react';
import { instanceOf, number } from 'prop-types';
import { connect } from 'react-redux';

import IECategoryDropdown from './IECategoryDropdown';
import IELoading from '../IELoading';

const CategorySelection = ({ ieCategories, categoryId }) => {
  const { loading, data } = ieCategories;
  const category = data.length > 0 && categoryId && data.find(cat => cat.id === categoryId);
  return (
    <div className="ie--card ie--settings--category">
      <div className="ie--card--body">
        <div className="ie--card--col">
          <h2 className="ie--card--title">Category</h2>
          {loading && <IELoading />}
          {!loading && data.length === 0 && <div>No category found.</div>}
          {data.length > 0 && <IECategoryDropdown />}
        </div>
        <div className="ie--card--col">
          <h3 className="ie--card--title">Selection</h3>
          {!ieCategories.loading && categoryId && category && (
            <div className="ie--settings--selection">
              {category.name}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

CategorySelection.propTypes = {
  ieCategories: instanceOf(Object),
  categoryId: number,
};

CategorySelection.defaultProps = {
  categoryId: null,
  ieCategories: {
    loading: true,
    error: false,
    data: [],
  },
};

const mapStateToProps = ({ turnkeyOmnibus }) => {
  const { ieCategories, surveyInfo } = turnkeyOmnibus;
  return {
    ieCategories,
    categoryId: surveyInfo.categoryId,
  };
};

export default connect(
  mapStateToProps,
  null,
)(CategorySelection);
